import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalTermsOfUseSL extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Pogoji in določila';
		const siteDescription =
			'Z dostopom do spletnega mesta Glossiq in oddajo naročila potrjujete, da se strinjate s pogoji storitve, navedenimi v opisanih Pogojih in določilih. Ti pogoji veljajo za celotno spletno mesto in za vsa elektronska poštna sporočila ali druga komunikacijska sredstva med vami in Glossiq.';
		const siteKeywords = 'Terms of use default keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/termsofuse/sl';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Pogoji in določila</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<InfoPageTitle1>Splošni pogoji </InfoPageTitle1>
						<p>
							Z dostopom do spletnega mesta Glossiq in oddajo naročila potrjujete, da se strinjate s pogoji storitve,
							navedenimi v opisanih Pogojih in določilih. Ti pogoji veljajo za celotno spletno mesto in za vsa
							elektronska poštna sporočila ali druga komunikacijska sredstva med vami in Glossiq.
						</p>
						<p>
							V nobenem primeru ekipa Glossiq ne odgovarja za neposredno, posredno, posebno, posledično ali naključno
							škodo, vključno z izgubo podatkov ali dobička, ki izhaja iz uporabe ali nezmožnosti uporabe gradiv na tem
							spletnem mestu, tudi če je bila ekipa Glossiq ali pooblaščeni predstavnik seznanjen z možnostjo take
							škode. Če uporaba gradiv s tega spletnega mesta povzroči potrebo po vzdrževanju, popravilu ali popravku
							opreme ali podatkov, prevzemate vse stroške v zvezi s tem.
						</p>
						<p>
							Glossiq ne prevzema odgovornosti za kakršenkoli izid, ki se lahko pojavi med uporabo naših virov.
							Pridržujemo si pravico do spremembe cen in pregleda politike uporabe virov v vsakem trenutku.
						</p>

						<InfoPageTitle1>Licenca </InfoPageTitle1>

						<p>
							Glossiq vam podeljuje preklicljivo, neizključno, neprenosljivo in omejeno dovoljenje za prenos, namestitev
							in uporabo spletnega mesta v skladu s pogoji tega sporazuma.
						</p>

						<p>
							Ti Pogoji in določila so pogodba med vami in Glossiq (v teh pogojih in določilih imenovan "Glossiq", "mi",
							"nas" ali "naša"), ponudnikom spletnega mesta Glossiq in storitev, dostopnih prek spletnega mesta Glossiq
							(ki se v teh pogojih in določilih skupno imenujejo "Glossiq storitev").
						</p>

						<p>
							S strinjanjem s temi Pogoji in določili se strinjate, da ste vezani na te pogoje in določila. Če se ne
							strinjate s temi pogoji in določili, prosimo, da ne uporabljate storitve Glossiq. V teh Pogojih in
							določilih se izraz "vi" nanaša tako na vas kot posameznika kot tudi na pravno osebo, ki jo zastopate. Če
							kršite katero od teh Pogojev in določil, si pridržujemo pravico, da brez predhodnega obvestila prekličemo
							vaš račun ali blokiramo dostop do vašega računa.
						</p>

						<InfoPageTitle1>Definicije in ključni pojmi</InfoPageTitle1>
						<p>Da bi stvari čim bolj jasno pojasnili v Pogojih in določilih, so naslednji pojmi strogo definirani:</p>
						<ul>
							<li>
								Piškotek: majhna količina podatkov, ki jih spletno mesto ustvari in shrani v vašem spletnem brskalniku.
								Uporablja se za identifikacijo vašega brskalnika, zagotavljanje analitike ter shranjevanje informacij o
								vas, kot so vaše jezikovne preference ali podatki za prijavo.
							</li>
							<li>
								odjetje: ko ti pogoji omenjajo "Podjetje", "mi", "nas" ali "naše", se nanašajo na Glossiq, ki je
								odgovoren za vaše informacije v skladu s temi Pogoji in določili.
							</li>
							<li>Država: država, v kateri je Glossiq ali lastniki/ustanovitelji Glossiqa, v tem primeru Slovenija.</li>
							<li>
								Naprava: katerakoli internetno povezana naprava, kot je telefon, tablica, računalnik ali katerakoli
								druga naprava, ki jo je mogoče uporabiti za obisk Glossiqa in uporabo storitev.
							</li>
							<li>
								Storitev: nanaša se na storitev, ki jo Glossiq zagotavlja, kot je opisano v ustrezno navedenih pogojih
								(če so na voljo) in na tej platformi.
							</li>
							<li>
								Storitev tretjih oseb: nanaša se na oglaševalce, sponzorje, partnerske in trženjske partnerje ter druge,
								ki zagotavljajo našo vsebino ali katerih izdelki ali storitve bi vas lahko zanimale.
							</li>
							<li>Spletno mesto: spletno mesto Glossiq, ki je dostopno prek naslednjega URL-ja: www.glossiq.com</li>
							<li>Vi: fizična ali pravna oseba, ki se je registrirala pri Glossiq za uporabo storitev.</li>
						</ul>

						<InfoPageTitle1>Omejitve </InfoPageTitle1>

						<p>Strinjate se, da ne boste in drugim ne boste dovolili:</p>

						<ul>
							<li>
								Licencirati, prodajati, oddajati v najem, dajati v podnajem, dodeljevati, distribuirati, prenašati,
								gostiti, izvajati zunaj vira, razkriti ali na kakršen koli drug način komercialno izkoriščati spletno
								mesto ali omogočati platformo tretji osebi.
							</li>

							<li>
								Spreminjati, ustvarjati izpeljane izdelke, razstavljati, dešifrirati, preoblikovati kodo, prevajati ali
								na kakršen koli način razstavljati ali inženirsko rekonstruirati katerikoli del spletnega mesta.
							</li>

							<li>
								Odstranjevati, spreminjati ali prikrivati kakršnokoli lastniško obvestilo (vključno z obvestili o
								avtorskih pravicah ali blagovnih znamkah) Glossiqa ali njegovih podružnic, partnerjev, dobaviteljev ali
								licencodajalcev spletnega mesta.
							</li>
						</ul>

						<InfoPageTitle1>Plačilo </InfoPageTitle1>

						<p>
							Če se prijavite na katerikoli naš ponavljajoči se plačilni načrt, se strinjate, da boste, v skladu s
							takrat veljavnimi cenami, stroški in pogoji obračunavanja, plačali vse pristojbine ali stroške za
							storitev. Razen če je drugače navedeno na naročilnici, morate Glossiqu posredovati veljavno kreditno
							kartico (Visa, MasterCard ali katerokoli drugo potrjeno plačilno obliko) ("Ponudnik plačil"), kot pogoj za
							prijavo na Premium načrt. Vaša pogodba s ponudnikom plačil ureja uporabo določenega kreditnega kartičnega
							računa, zato se glede svojih pravic in obveznosti v zvezi s ponudnikom plačil sklicujte na vašo pogodbo in
							ne na te Pogoje. S posredovanjem številke svoje kreditne kartice in povezanih plačilnih informacij
							Glossiqu, se strinjate, da je Glossiq pooblaščen, da takoj preveri informacije in nato izda račun za vse
							pristojbine in stroške, ki jih je treba plačati Glossiqu v skladu s temi Pogoji, in da ni potrebno dodatno
							obvestilo ali soglasje. Sprejeli ste, da boste Glossiq takoj obvestili o vsaki spremembi naslova za
							obračun ali spremembi kreditne kartice, uporabljene za plačilo. Glossiq si pridržuje pravico, da kadarkoli
							spremeni cene in načine obračunavanja, bodisi takoj po objavi na našem spletnem mestu bodisi z dostavo po
							e-pošti vašemu administratorju ali administratorjem organizacije.
						</p>

						<p>
							Vse pristojbine odvetnikov, sodnih stroškov ali drugih stroškov, nastalih pri izterjavi neplačanih
							neizpodbijanih zneskov, so vaša odgovornost in jih morate plačati.
						</p>

						<p>
							Pogodba med vami in Glossiq za storitev ne bo potrjena, dokler Glossiq ne sprejme vašega naročila s
							potrditvenim e-poštnim sporočilom, SMS/MMS sporočilom ali drugim ustreznim sredstvom komunikacije.
						</p>

						<p>Za vse pristojbine tretjih oseb, ki bi nastale pri uporabi storitve, ste odgovorni vi.</p>

						<InfoPageTitle1>Politika vračila in vračilo denarja</InfoPageTitle1>

						<p>
							Hvala, ker ste se odločili za nakup pri Glossiq. Veseli nas, da vam je všeč naša ponudba. Prav tako želimo
							zagotoviti, da boste pri raziskovanju in nakupovanju naših izdelkov in storitev zadovoljni.
						</p>

						<p>
							Za transakcije pri Glossiq veljajo določeni pogoji in določila. Z oddajo naročila ali nakupom pri Glossiq
							sprejmete te pogoje skupaj s Politiko zasebnosti Glossiq.
						</p>

						<p>
							V primeru, da iz kateregakoli razloga niste povsem zadovoljni z našim izdelkom ali storitvijo, vas vljudno
							prosimo, da nas kontaktirate. Zavezujemo se, da bomo obravnavali vse težave, s katerimi se soočate pri
							našem izdelku oziroma storitvi.
						</p>

						<InfoPageTitle1>Vaši predlogi </InfoPageTitle1>

						<p>
							Vse povratne informacije, komentarji, ideje, izboljšave ali predlogi (skupaj imenovani "Predlogi"), ki jih
							posredujete Glossiqu glede spletnega mesta, ostajajo izključna last Glossiqa.
						</p>

						<p>
							Glossiq ima pravico uporabljati, kopirati, spreminjati, objavljati ali distribuirati predloge brez
							kakršnih koli omejitev glede namena ali načina uporabe, brez priznanja avtorstva ali kakršnekoli
							odškodnine za vas.
						</p>

						<InfoPageTitle1>Vaše soglasje</InfoPageTitle1>

						<p>
							Z uporabo našega spletnega mesta, registracijo računa ali nakupom izrecno soglašate z našimi Pogoji in
							določili.
						</p>

						<InfoPageTitle1>Povezave do drugih spletnih mest</InfoPageTitle1>

						<p>
							Ti Pogoji in določila veljajo le za Storitve. Storitve lahko vsebujejo povezave do drugih spletnih mest,
							ki jih ne upravlja ali nadzoruje Glossiq. Ne prevzemamo odgovornosti za vsebino, točnost ali izražena
							mnenja na takšnih spletnih mestih, ki niso preiskovana, nadzorovana ali preverjena glede točnosti ali
							popolnosti s strani nas. Upoštevajte, da ko uporabite povezavo, ki vas s Storitev usmeri na drugo spletno
							mesto, naši Pogoji in določila ne veljajo več. Vaše brskanje in interakcija na kateremkoli drugem spletnem
							mestu, vključno s tistimi, ki imajo povezavo na naši platformi, je podvrženo lastnim pravilom in politikam
							tega spletnega mesta. Takšne tretje osebe lahko uporabljajo svoje piškotke ali druge metode za zbiranje
							informacij o vas.
						</p>

						<InfoPageTitle1>Piškotki </InfoPageTitle1>

						<p>
							Glossiq uporablja "Piškotke" (Cookies), ki omogočajo prepoznavanje področij naše spletne strani, ki ste
							jih obiskali. Piškotek je majhen kos podatkov, ki ga vaš spletni brskalnik shrani na vaš računalnik ali
							mobilno napravo. Piškotke uporabljamo za izboljšanje delovanja in funkcionalnosti naše spletne strani,
							vendar le-ti niso nujni za njeno uporabo. Brez sprejetja piškotkov določene funkcionalnosti, kot so
							videoposnetki, morda ne bodo na voljo, ali pa boste morali vsakič vnašati svoje podatke za prijavo, saj se
							vaši podatki ne shranjujejo. Če onemogočite piškotke, morda ne boste mogli pravilno ali sploh dostopati do
							funkcionalnosti naše spletne strani. V piškotke nikoli ne vključujemo osebnih identifikacijskih podatkov.
						</p>

						<InfoPageTitle1>Spremembe Pogojev in določil</InfoPageTitle1>

						<p>
							Soglašate in se strinjate, da si Glossiq pridržuje pravico (trajno ali začasno) prenehati zagotavljati
							Storitev (ali katerokoli funkcionalnost znotraj Storitve) vam ali uporabnikom na splošno, po izključni
							presoji Glossiqa, brez predhodnega obvestila. Kadarkoli lahko prenehate uporabljati Storitev. O tem, da
							prenehate z uporabo Storitve vam ni potrebno posebej obvestiti Glossiqa. Soglašate in se strinjate, da če
							Glossiq onemogoči dostop do vašega računa, vam lahko prepreči dostop do Storitve, podrobnosti vašega
							računa ali datotek ali drugih gradiv, ki se nahajajo v vašem računu.
						</p>

						<p>
							V primeru sprememb Pogojev in določil, bomo spremembe objaviti na tej strani in/ali posodobili datum
							spremembe Pogojev in določil spodaj.
						</p>

						<InfoPageTitle1>Spremembe naše spletne strani</InfoPageTitle1>

						<p>
							Glossiq si pridržuje pravico, da brez obveznosti do vas spremeni, začasno ali trajno prekine spletno stran
							ali katero koli storitev, ki je povezana s spletno stranjo, bodisi s predhodnim obvestilom ali brez njega.
						</p>

						<InfoPageTitle1>Posodobitve naše spletne strani</InfoPageTitle1>

						<p>
							Glossiq lahko občasno zagotavlja izboljšave ali posodobitve funkcionalnosti spletne stra ni, kar lahko
							vključuje popravke, odpravo napak, posodobitve, nadgradnje in druge spremembe.
						</p>

						<p>
							Posodobitve lahko spremenijo ali izbrišejo določene funkcionalnosti spletne strani. Strinjate se, da
							Glossiq ni zavezan (i) zagotavljati nobenih Posodobitev ali (ii) nadaljevati zagotavljanje ali omogočanje
							določenih funkcionalnosti spletne strani.
						</p>

						<p>
							Poleg tega se strinjate, da bodo vse Posodobitve (i) štele za sestavni del spletne strani in (ii)
							podvržene pogojem tega sporazuma.
						</p>

						<InfoPageTitle1>Storitve tretjih oseb </InfoPageTitle1>

						<p>
							Naša spletna stran lahko prikaže, vključi ali omogoči vsebine tretjih oseb (vključno s podatki,
							informacijami, aplikacijami in drugimi izdelki ali storitvami) ali ponuja povezave do spletnih mest ali
							storitev tretjih oseb ("Storitve tretjih oseb").
						</p>

						<p>
							Soglašate in se strinjate, da Glossiq ni odgovoren za nobene Storitve tretjih oseb, vključno z njihovo
							točnostjo, popolnostjo, ažurnostjo, veljavnostjo, skladnostjo z avtorskimi pravicami, zakonitostjo,
							primernostjo, kakovostjo ali katerimkoli drugim vidikom. Glossiq ne prevzema nobene odgovornosti ali
							obveznosti do vas ali kogar koli drugega za Storitve tretjih oseb.
						</p>

						<p>
							Storitve tretjih oseb in povezave do njih se ponujajo zgolj kot priročnost za vas in do njih dostopate ter
							jih uporabljate izključno na lastno odgovornost in v skladu s pogoji tretjih oseb.
						</p>

						<InfoPageTitle1>Trajanje in prenehanje sporazuma</InfoPageTitle1>

						<p>Ta sporazum ostaja veljaven do preklica z vaše strani ali s strani Glossiq.</p>

						<p>
							Glossiq lahko po lastni presoji kadarkoli, zaradi kateregakoli razloga ali brez njega prekine ta sporazum
							s predhodnim obvestilom ali brez njega.
						</p>

						<p>
							V primeru neizpolnjevanja določil tega sporazuma, ta sporazum prenega veljati takoj, brez predhodnega
							obvestila s strani Glossiq. Prav tako lahko vi prekinete ta sporazum tako, da izbrišete spletno stran in
							vse njene kopije s svojega računalnika.
						</p>

						<p>
							Po prenehanju tega sporazuma morate prenehati uporabljati spletno stran in izbrisati vse kopije spletne
							strani s svojega računalnika.
						</p>

						<p>
							Prenehanje tega sporazuma ne bo omejilo nobenih pravic ali pravnih sredstev Glossiqa v primeru kršitve
							vaših obveznosti po tem sporazumu med trajanjem tega sporazuma.
						</p>

						<InfoPageTitle1>Obvestilo o kršitvi avtorskih pravic</InfoPageTitle1>

						<p>
							Če ste imetnik avtorskih pravic ali pooblaščena oseba takšnega imetnika in menite, da katerikoli element
							na naši spletni strani predstavlja kršitev vaše avtorske pravice, nas prosimo kontaktirajte in navedite
							naslednje informacije: (i) fizični ali elektronski podpis imetnika avtorskih pravic ali osebe, pooblaščene
							za delovanje v njegovem imenu; (ii) identifikacija elementa, za katerega se trdi, da krši avtorske
							pravice; (iii) vaše kontaktne podatke, vključno z naslovom, telefonsko številko in elektronskim naslovom;
							(iv) izjava, da menite, da uporaba materiala ni pooblaščena s strani imetnikov avtorskih pravic; in (v)
							izjava, da so informacije v obvestilu točne in da ste po zakonu in pod kazensko odgovornostjo pooblaščeni
							za delovanje v imenu imetnika pravic.
						</p>

						<InfoPageTitle1>Odškodnina </InfoPageTitle1>

						<p>
							Strinjate se, da boste povrnili škodo in zavarovali Glossiq ter njegove matične družbe, podružnice,
							povezane družbe, uradnike, zaposlene, agente, partnerje in pooblaščence (če obstajajo) pred kakršnim koli
							zahtevkom ali zahtevami, vključno z razumnimi odvetniškimi stroški, ki izhajajo iz ali so povezani z
							vašim: (i) uporabo spletne strani; (ii) kršitvijo tega sporazuma ali kateregakoli zakona ali predpisa; ali
							(iii) kršitvijo pravic tretje osebe.
						</p>

						<InfoPageTitle1>Brez garancij </InfoPageTitle1>

						<p>
							Spletna stran se vam zagotavlja "TAKA, KOT JE" in "TAKA, KOT JE NA VOLJO", z vsemi napakami in
							pomanjkljivostmi, brez kakršnihkoli jamstev. V največjem obsegu, dovoljenem z veljavno zakonodajo,
							Glossiq, v svojem imenu in v imenu svojih povezanih družb ter njihovih licencodajalcev in ponudnikov
							storitev, izrecno zavrača vsa jamstva, bodisi izrecna, implicitna, zakonska ali kako drugače, v zvezi s
							spletno stranjo, vključno z vsemi implicitnimi jamstvi glede tržnosti, ustreznosti za določen namen,
							naslova in nekršitve ter jamstvi, ki izhajajo iz poteka poslovanja, izvajanja, uporabe ali prodaje. Brez
							omejevanja zgoraj navedenega Glossiq ne zagotavlja nobenega jamstva ali zaveze ter ne daje nobenih izjav,
							da bo spletna stran izpolnila vaše zahteve, dosegla kakršnekoli želene rezultate, bo združljiva ali bo
							delovala z drugo programsko opremo, spletnimi mesti, sistemi ali storitvami, delovala brez prekinitve,
							izpolnjevala določene standarde učinkovitosti ali zanesljivosti, ali da bo brez napak, ali da bodo napake
							ali pomanjkljivosti lahko odpravljene.
						</p>

						<p>
							Brez omejevanja zgoraj navedenega ne Glossiq ne noben ponudnik Glossiq ne daje nobene izjave ali jamstva
							katerekoli vrste, bodisi izrecnega ali implicitnega: (i) glede delovanja ali razpoložljivosti spletne
							strani ali informacij, vsebin in materialov ali izdelkov, vključenih vanjo; (ii) da bo spletna stran
							delovala neprekinjeno ali brez napak; (iii) glede točnosti, zanesljivosti ali aktualnosti informacij ali
							vsebin, zagotovljenih preko spletne strani; ali (iv) da so spletna stran, njeni strežniki, vsebine ali
							e-poštna sporočila, poslana s strani Glossiq ali v njegovem imenu, brez virusov, skriptov, trojanskih
							konjev, črvov, zlonamerne programske opreme, časovnih bomb (»time bombs«) ali drugih škodljivih sestavin.
						</p>

						<p>
							Nekatere pravne jurisdikcije ne dovoljujejo izključitve ali omejitev implicitnih jamstev ali omejitev
							veljavnih zakonskih pravic potrošnikov, zato se nekatere ali vse zgoraj navedene izključitve in omejitve
							morda ne nanašajo na vas. V teh primerih se lahko določbe in pravice, ki vam jih zagotavlja zakonodaja
							vaše jurisdikcije, še vedno uporabljajo.
						</p>

						<InfoPageTitle1>Omejitev odgovornosti</InfoPageTitle1>

						<p>
							Ne glede na morebitno škodo, ki bi vam lahko nastala, je celotna odgovornost Glossiqa in vseh njegovih
							dobaviteljev v skladu s katerokoli določbo tega sporazuma in vaša izključna pravna sredstva za vse zgoraj
							navedeno omejena na znesek, ki ga dejansko plačate za spletno mesto.
						</p>

						<p>
							V največji možni meri, dovoljeni s pravom, v nobenem primeru Glossiq ali njegovi dobavitelji ne
							odgovarjajo za posebno, naključno, posredno ali posledično škodo (vključno, vendar ne omejeno na škodo
							zaradi izgube dobička, izgube podatkov ali drugih informacij, prekinitve poslovanja, osebne poškodbe,
							izgube zasebnosti, ki izhajajo iz uporabe ali nemožnosti uporabe spletnega mesta, programske opreme
							tretjih oseb in/ali strojne opreme tretjih oseb, uporabe spletnega mesta, ali na kakršen koli drug način v
							zvezi z določbami tega sporazuma), tudi če je bil Glossiq ali katerikoli dobavitelj obveščen o možnosti
							takšne škode, ali če sredstvo za odpravo okvare ne doseže svojega bistvenega namena.
						</p>

						<p>
							V nekaterih državah/jurisdikcijah ni dovoljeno izključiti ali omejiti naključne ali posledične škode, zato
							zgornja omejitev ali izključitev morda ne velja za vas.
						</p>

						<InfoPageTitle1>Klavzula o ločljivosti</InfoPageTitle1>

						<p>
							Če se ugotovi, da je katerakoli določba tega sporazuma neizvršljiva ali neveljavna, se bo takšna določba
							spremenila in razlagala tako, da se doseže največji možni obseg ciljev te določbe v skladu s pravom,
							preostale določbe bodo ostale v polni veljavi.
						</p>

						<p>
							Ta sporazum, skupaj z Izjavo o zasebnosti in morebitnimi drugimi pravnimi obvestili, ki jih Glossiq objavi
							na storitvah, predstavlja celoten sporazum med vami in Glossiq v zvezi s storitvami. Če katerakoli določba
							tega sporazuma velja za neveljavno s strani pristojnega sodišča, neveljavnost te določbe ne vpliva na
							veljavnost preostalih določb tega sporazuma, ki ostajajo v polni veljavi. Nobeno odstopanje od katerekoli
							določbe tega sporazuma se ne šteje za nadaljnje ali trajno odstopanje od te določbe ali katerekoli druge
							določbe, in opustitev Glossiqa, da uveljavi katerokoli pravico ali določbo tega sporazuma, ne predstavlja
							odstopanja od te pravice ali določbe. VI IN GLOSSIQ SE STRINJATE, DA MORA KAKRŠNAKOLI TOŽBA, KI IZHAJA IZ
							STORITEV ALI JE POVEZANA Z NJIMI, ZAČETI V ENEM (1) LETU PO NASTANKU VZROKA ZA TOŽBO. V NASPROTNEM PRIMERU
							JE TAKA TOŽBA TRAJNO ZAVRNJENA.
						</p>

						<InfoPageTitle1>Odstop </InfoPageTitle1>

						<p>
							Razen če je drugače določeno s tem sporazumom, neizvršitev pravice ali zahteva po izpolnitvi obveznosti v
							skladu s tem sporazumom ne vpliva na zmožnost katerekoli stranke, da kasneje uveljavlja to pravico ali
							zahteva izpolnitev takšne obveznosti, in odstop od kršitve ne pomeni odstopa od morebitnih nadaljnjih
							kršitev.
						</p>

						<p>
							Neizvršitev ali zamuda pri izvrševanju pravice ali pooblastila s strani katerikoli stranki v skladu s tem
							sporazumom ne pomeni odstopa od te pravice ali pooblastila. Prav tako nobeno posamično ali delno
							izvrševanje katerekoli pravice ali pooblastila v skladu s tem sporazumom ne izključuje nadaljnjega
							izvrševanja te ali katerekoli druge pravice, dodeljene v tem sporazumu. V primeru konflikta med tem
							sporazumom in morebitnimi veljavnimi pogoji nakupa ali drugimi pogoji, se uporabljajo določbe tega
							sporazuma.
						</p>

						<InfoPageTitle1>Spremembe sporazuma</InfoPageTitle1>

						<p>
							Glossiq si pridržuje pravico, po lastni presoji, da kadarkoli spremeni ali nadomesti ta sporazum. V
							primeru bistvene spremembe bomo zagotovili najmanj 30 dni predhodnega obvestila, preden začnejo veljati
							nove določbe. Po naši lastni presoji bomo določili, kaj predstavlja bistveno spremembo.
						</p>

						<p>
							Z nadaljnjim dostopom ali uporabo naše spletne strani po uveljavitvi katerekoli spremembe, se strinjate,
							da ste zavezani k spremenjenim določbam. Če se ne strinjate z novimi pogoji, nimate več dovoljenja za
							uporabo Glossiq.
						</p>

						<InfoPageTitle1>Celoten sporazum </InfoPageTitle1>

						<p>
							Sporazum predstavlja celoten sporazum med vami in Glossiq glede vaše uporabe spletne strani in nadomešča
							vse prejšnje pisne ali ustne sporazume med vami in Glossiq.
						</p>

						<p>
							Lahko ste podvrženi dodatnim pogojem, ki veljajo pri uporabi ali nakupu drugih storitev Glossiq, ki vam
							jih bo Glossiq zagotovil ob takšni uporabi ali nakupu.
						</p>

						<InfoPageTitle1>Posodobitve naših pogojev</InfoPageTitle1>

						<p>
							Pridržujemo si pravico do sprememb Storitev in pravilnikov, da bodo natančno odražale naše Storitve in
							pravilnike. Razen če je drugače zahtevano z zakonom, vas bomo obvestili (na primer preko naše Storitve)
							preden naredimo spremembe teh pogojev in vam dali možnost, da jih pregledate, preden začnejo veljati. Če
							nadaljujete z uporabo Storitve, boste zavezani posodobljenim pogojem. Če se ne strinjate s temi ali
							katerimikoli posodobljenimi pogoji, lahko izbrišete svoj račun.
						</p>

						<InfoPageTitle1>Intelektualna lastnina</InfoPageTitle1>

						<p>
							Spletna stran in vse njene vsebine, funkcije in elementi (vključno, vendar ne omejeno na vse informacije,
							programske opreme, besedila, prikaze, slike, video posnetke in avdio posnetke ter njihovo oblikovanje,
							izbor in razporeditev), so last Glossiqa, njegovih licencodajalcev ali drugih ponudnikov takega gradiva in
							so zaščitene s slovenskim in mednarodnim avtorskimi pravicami, blagovnimi znamkami, patenti, poslovnimi
							skrivnostmi in drugimi pravicami intelektualne lastnine. Gradivo se ne sme kopirati, spreminjati,
							reproducirati, prenašati ali distribuirati na noben način, v celoti ali delno, brez izrecnega predhodnega
							pisnega dovoljenja Glossiqa, razen kot je izrecno določeno v teh Pogojih in določilih. Vsaka nepooblaščena
							uporaba gradiva je prepovedana.
						</p>

						<InfoPageTitle1>Sporazum o arbitraži</InfoPageTitle1>

						<p>
							Ta odsek se nanaša na kakršen koli spor, RAZEN SPORA V ZVEZI Z ZAHTEVKI ZA INJUNKTIVNO ALI EKVITETNO
							ODŠKODNINO V ZVEZI Z UVELJAVLJANJEM ALI VELJAVNOSTJO VAŠIH ALI INTELEKTUALNIH LASTNINSKIH PRAVIC GLOSSIQ.
							Izraz "spor" pomeni kakršen koli spor, tožbo ali drug spor med vami in Glossiq v zvezi s storitvami ali
							tem sporazumom, bodisi na podlagi pogodbe, garancije, protipravnega ravnanja, zakona, predpisa, odloka ali
							katerekoli druge pravne ali pravične podlage. Izraz "spor" bo imel najširši možen pomen, ki ga dovoljuje
							zakon.
						</p>

						<InfoPageTitle1>Obvestilo o sporu</InfoPageTitle1>

						<p>
							V primeru spora mora Glossiq ali vi drugi stranki poslati Obvestilo o sporu, ki je pisna izjava, ki
							vsebuje ime, naslov in kontaktne informacije stranke, ki podaja obvestilo, dejstva o vzroku spora ter
							zahtevano odškodnino. Obvestilo o sporu morate poslati po elektronski pošti na naslov:
							support@glossiq.com. Glossiq vam bo poslal Obvestilo o sporu po pošti na vaš naslov, če ga hranimo, ali pa
							na vaš elektronski naslov. Vi in Glossiq bosta skušala rešiti spor z neformalnimi pogajanji v šestdesetih
							(60) dneh od datuma, ko je bilo poslano Obvestilo o sporu. Po preteku šestdesetih (60) dni lahko vi ali
							Glossiq sprožita arbitražo.
						</p>

						<InfoPageTitle1>Zavezujoča arbitraža</InfoPageTitle1>

						<p>
							Če vi in Glossiq ne rešite spora z neformalnimi pogajanji, se vsak drugi poskus reševanja spora izvede
							izključno z vezano arbitražo, kot je opisano v tem poglavju. S tem opuščate pravico do sodnega postopka
							(ali sodelovanja kot stranka ali član) vseh sporov pred sodnikom ali poroto. Spor bo rešen z vezano
							arbitražo v skladu s komercialnimi arbitražnimi pravili Ameriške arbitražne zveze. Katerakoli stranka
							lahko zaprosi za začasno ali predhodno sodno prepoved pri kateremkoli pristojnem sodišču, če je to
							potrebno za zaščito pravic ali premoženja stranke do končanja arbitraže. Vse pravne, računovodske in druge
							stroške, pristojbine in izdatke, ki jih zmagovalna stranka nosi, mora plačati stranka, ki ni zmagala.
						</p>

						<InfoPageTitle1>Predložitve in zasebnost</InfoPageTitle1>

						<p>
							V primeru, da predložite ali objavite kakršnekoli ideje, ustvarjalne predloge, fotografije, informacije,
							oglase, podatke ali predloge, vključno z idejami za nove ali izboljšane izdelke, storitve, funkcije,
							tehnologije ali promocije, se izrecno strinjate, da se takšne predloge samodejno obravnava kot nezaupne in
							nelastniške, in postanejo izključna last Glossiq brez kakršnegakoli nadomestila ali priznanja. Glossiq in
							njegove povezane družbe nimajo nobenih obveznosti glede takšnih predlogov ali objav in lahko uporabljajo
							ideje, ki jih vsebujejo takšni predlogi ali objave, za katerikoli namen v kateremkoli mediju za nedoločen
							čas, vključno, vendar ne omejeno na, razvoj, proizvodnjo in trženje izdelkov in storitev s pomočjo takšnih
							idej.
						</p>

						<InfoPageTitle1>Promocije </InfoPageTitle1>

						<p>
							Glossiq lahko občasno organizira nagradne igre, promocije, žrebanja ali druge aktivnosti ("Promocije"), ki
							zahtevajo, da predložite gradivo ali informacije o sebi. Upoštevajte, da so lahko vse Promocije urejene z
							ločenimi pravili, ki vsebujejo določene pogoje upravičenosti, kot so omejitve glede starosti in
							geografskega območja. Vi ste odgovorni za branje vseh pravil Promocij, da ugotovite, ali ste upravičeni
							sodelovati ali ne. Če se prijavite na katerokoli Promocijo, se strinjate, da se boste držali in spoštovali
							vsa pravila Promocij.
						</p>

						<p>
							Dodatni pogoji in določila se lahko uporabljajo za nakup blaga ali storitev prek Storitev, ki so sestavni
							del tega sporazuma.
						</p>

						<InfoPageTitle1>Tiskarske napake </InfoPageTitle1>

						<p>
							V primeru, da je pri izdelku in/ali storitvi navedena napačna cena ali napačna informacija zaradi
							tiskarske napake, imamo pravico zavrniti ali preklicati naročila za izdelek in/ali storitev, ki so
							navedeni po napačni ceni. Prav tako imamo pravico zavrniti ali preklicati takšno naročilo, ne glede na to,
							ali je bilo naročilo potrjeno in ali je bila vaša kreditna kartica bremenjena. Če je bila vaša kreditna
							kartica že bremenjena za nakup in je vaše naročilo preklicano, vam bomo takoj povrnili znesek na vaš račun
							ali drug račun za plačilo v višini zneska bremenitve.
						</p>

						<InfoPageTitle1>Razno </InfoPageTitle1>

						<p>
							Če zaradi kakršnegakoli razloga pristojno sodišče ugotovi, da je katerakoli določba teh Pogojev in
							določbil neizvršljiva, bodo preostali deli teh Pogojev in določil še naprej veljavni v celoti. Kakršno
							koli odstopanje od katerihkoli določil teh Pogojev in določil bo učinkovito samo, če bo napisano in
							podpisano s strani pooblaščenega predstavnika Glossiq. Glossiq bo upravičen do sodne prepovedi ali drugega
							pravičnega pravnega sredstva (brez obveznosti polaganja garancije ali poroštva) v primeru kakršnekoli
							kršitve ali predvidene kršitve z vaše strani. Glossiq deluje in nadzoruje Storitev Glossiq iz svojih
							pisarn v Sloveniji. Storitev ni namenjena distribuciji ali uporabi v nobeni jurisdikciji ali državi, kjer
							bi takšna distribucija ali uporaba bila v nasprotju z zakonom ali predpisi. Zato osebe, ki se odločijo
							dostopati do Storitve Glossiq iz drugih lokacij, to počnejo na lastno pobudo in so izključno odgovorne za
							skladnost z lokalnimi zakoni, če in kolikor so lokalni zakoni uporabni. Ti Pogoji in določila (ki
							vključujejo in upoštevajo Politiko zasebnosti Glossiq) predstavljajo celoten sporazum in nadomeščajo vse
							prejšnje sporazume med vami in Glossiq glede predmeta teh Pogojev in določil ter jih ni mogoče spremeniti
							ali modificirati vaše strani. Naslovi odstavkov, uporabljeni v tem sporazumu, so zgolj za pomoč in nimajo
							pravnega pomena.
						</p>

						<InfoPageTitle1>Zavrnitev odgovornosti </InfoPageTitle1>

						<p>Glossiq ni odgovoren za nobeno vsebino, kodo ali kakršno koli drugo nepravilno informacijo.</p>

						<p>Glossiq ne daje jamstev ali garancij.</p>

						<p>
							V nobenem primeru Glossiq ne bo odgovoren za kakršno koli posebno, neposredno, posredno, posledično ali
							naključno škodo ali za kakršno koli škodo, ne glede na to, ali gre za pogodbeno tožbo, malomarnost ali
							drugo odškodninsko tožbo, ki izhaja iz uporabe Storitve ali vsebine Storitve. Podjetje si pridržuje
							pravico, da kadarkoli brez predhodnega obvestila dodaja, izbriše ali spreminja vsebino Storitve.
						</p>

						<p>
							Storitev Glossiq in njena vsebina se zagotavljata "takšni, kot so" in "kot so na voljo", brez kakršnihkoli
							jamstev ali zagotovil, bodisi izrecnih ali implicitnih. Glossiq je distributer in ne založnik vsebine, ki
							jo zagotavljajo tretje osebe. Zato Glossiq ne izvaja uredniške kontrole nad to vsebino in ne zagotavlja
							garancije ali zagotovila glede natančnosti, zanesljivosti ali aktualnosti kakršnihkoli informacij,
							vsebine, storitev ali izdelkov, ki so na voljo preko Storitve Glossiq. Brez omejevanja zgoraj navedenega,
							Glossiq izrecno zavrača vsa jamstva in zagotovila v zvezi z vsebino, preneseno preko Storitve Glossiq ali
							na spletnih mestih, ki se pojavljajo kot povezave na Storitvi Glossiq, ali v izdelkih, ki so del Storitve
							Glossiq ali, ki so kako drugače povezani z njo, vključno brez omejitev z morebitnimi jamstvi glede
							primernosti za prodajo, primernosti za določen namen ali nekršitve pravic tretjih oseb. Nobenega ustnega
							nasveta ali pisnih informacij, ki jih poda Glossiq ali kater koli od njenih podružnic, zaposlenih,
							uradnikov, direktorjev, agentov ali podobnih oseb, se ne sme šteti za jamstvo. Informacije o cenah in
							razpoložljivosti se lahko spremenijo brez predhodnega obvestila. Brez omejevanja zgoraj navedenega,
							Glossiq ne jamči, da bo Storitev Glossiq neprekinjena, nepoškodovana, pravočasna ali brez napak.
						</p>

						<InfoPageTitle1>Kontaktirajte nas</InfoPageTitle1>
						<p>Če imate kakršnakoli vprašanja, nas kontaktirajte na spodnji elektronski naslov.</p>
						<p>
							Elektronski naslov: : <a href="mailto:support@glossiq.com">support@glossiq.com</a>
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalTermsOfUseSL };
